import React, { useEffect, useState } from 'react';

export default function SplashScreen({ visible = true, onFinish = () => {} }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!visible) return;
    setProgress(0);
    const duration = 5000;
    let rafId = null;
    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const pct = Math.min(100, (elapsed / duration) * 100);
      setProgress(pct);
      if (elapsed < duration) {
        rafId = requestAnimationFrame(tick);
      } else {
        // ensure we finish at exactly 100%
        setProgress(100);
        try { onFinish(); } catch (e) { /* ignore */ }
      }
    };
    rafId = requestAnimationFrame(tick);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [visible, onFinish]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      display: 'grid', placeItems: 'center',
      background: 'radial-gradient(circle at top, #3b1f10 0%, #160b06 70%)',
      color: '#f0d8a4',
      WebkitTapHighlightColor: 'transparent',
      pointerEvents: 'none',
    }}>
      <div style={{ textAlign: 'center', width: 'min(680px, 92vw)', padding: 16, pointerEvents: 'auto' }}>
        <div style={{ fontSize: '64px', fontWeight: 900, letterSpacing: 2, marginBottom: 8, fontFamily: 'Trebuchet MS, Arial, sans-serif', color: '#fff7e6' }}>Tavlapro</div>
        <div style={{ fontSize: '18px', opacity: 0.95, marginBottom: 10, color: '#f6e7c1' }}>Classic Backgammon</div>
        <div style={{
          margin: '14px auto 0',
          width: 'min(320px, 72%)',
          padding: '12px 14px',
          borderRadius: 10,
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.04)',
          color: '#cfd8dc',
          fontSize: 13,
        }}>
          <div style={{
            height: 10,
            borderRadius: 8,
            background: 'rgba(255,255,255,0.06)',
            overflow: 'hidden',
          }}>
            <div style={{
              width: `${progress}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #d7b16a, #8b5a2b)',
              transition: 'width 600ms cubic-bezier(.2,.9,.2,1)',
            }} />
          </div>
          {/* <div style={{ marginTop: 8, fontSize: 12, opacity: 0.95, textAlign: 'center' }}>{progress}%</div> */}
        </div>
      </div>
    </div>
  );
}
